import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const Toggle = (props) => {
  const { className, onChange, checked, name, disabled } = props;
  const componentClassName = "sal-toggle";
  const componentClass = classnames(componentClassName, className);

  return (
    <label className={componentClass}>
      <input
        className={componentClass + "__checkbox"}
        aria-labelledby={`filter-${name}`}
        onChange={onChange}
        checked={checked}
        type="checkbox"
        name={name}
        disabled={disabled}
      />
      <span className={componentClass + "__slider"}></span>
    </label>
  );
};

Toggle.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  filterInfoText: PropTypes.string.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Toggle;
